import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import $ from 'jquery';
import QRCode from 'qrcodejs2';
import lsDetail from '../../components/lsDetail.vue';
import lsDetailScript from '../../components/lsDetailScript.vue';
import bigImg from '../../components/bigImg.vue';
var qrcode;
var stageUrl = process.env.VUE_APP_IMG_URL;
var timer;
export default {
  name: 'springwaterDetail',
  meta: {
    title: '文物综合展示系统'
  },
  data() {
    return {
      singleform: {
        deptId: '',
        formId: ''
      },
      detailData: {
        deptId: '',
        formId: ''
      },
      detail: {},
      swiperEl: '',
      showModels: [false, false, false],
      list: [],
      listPage: 1,
      listTotal: 0,
      detailCode: '',
      activeIndex: -1,
      activeDetail: {},
      swiperElImg: '',
      swiperElNav: '',
      config: {},
      columns: [],
      columnName: '',
      showBigErCode: false,
      showDetail: false,
      pageType: '',
      showBigImg: false,
      showBigImgIndex: 0,
      showNavs: false,
      autoCloseNav: 0
    };
  },
  components: {
    lsDetail,
    bigImg,
    lsDetailScript
  },
  methods: {
    // 操作右侧分类
    touchstartNav() {
      this.autoCloseNav = 0;
      clearInterval(timer);
      timer = setInterval(() => {
        this.autoCloseNav++;
      }, 1000);
    },
    toIndex() {
      if (this.$route.query.hideOthers) return;
      this.$router.replace(`/springwaterList?fid=${this.$route.query.fid}${this.pageType ? `&type=${this.pageType}` : ''}`);
      // this.$router.replace(`/${this.$route.query.type != "luoshen" ? 'springwaterList' : 'new3DList'}?fid=${this.$route.query.fid}${this.pageType ? `&type=${this.pageType}` : ''}`)
    },
    // 点击左侧三个按钮
    showModel(index) {
      if (index == 1) return window.open(this.detail.zhuanti);
      this.showModels = this.showModels.map((item, i) => {
        i == index ? item = !item : '';
        return item;
      });
      if (index == 2 && this.showModels[2]) {
        this.$refs.voice.play();
      }
      if (index == 2 && !this.showModels[2]) {
        this.$refs.voice.pause();
      }
    },
    setParent(type, data) {
      if (type == 1 && this.$route.query.code) {
        this.list.splice(4, 0, data);
        if (this.swiperEl) {
          this.swiperEl.slideTo(4);
        }
        return;
      }
      this.detail = data;
    },
    hasZhuanti(data) {
      this.detail.zhuanti = data;
    },
    clickErCode() {
      this.showBigErCode = !this.showBigErCode;
      if (!this.showBigErCode) return;
      let query = this.$route.query;
      let url = window.location.href;
      this.$nextTick(() => {
        this.$refs.erWeiMaCode.innerHTML = '';
        new QRCode(this.$refs.erWeiMaCode, {
          text: url,
          //页面地址 ,如果页面需要参数传递请注意哈希模式#
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    //获取栏目列表
    getColumn() {
      let query = {
        deptId: this.$route.query.fid || '151066',
        formId: 112712,
        page: 1,
        limit: 50,
        orderBy: 'manualOrderTop,manualOrder',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(query).then(res => {
        this.setColumnData(res.dataList);
      });
    },
    toColumn(item, index) {
      this.swiperElNav.slideTo(index);
      this.columnName = item == '全部' ? '' : item;
      this.listPage = 1;
      if (this.detail.type == '3D') {
        let query = {
          fid: this.$route.query.fid,
          columnName: item
          // code: this.$route.query.code,
        };
        return this.$router.replace({
          name: `springwaterDetail`,
          query
        });
        // this.$refs.lsDetail.clearScene('changeColumn')
      }
      this.swiperEl.off('slideChangeTransitionEnd');
      this.getList('changeColumn');
    },
    //栏目信息解析
    setColumnData(data) {
      let list = data.map(item => {
        let nItem = {
          columnName: item.formIdValueData.name.groupValues[0] ? item.formIdValueData.name.groupValues[0].values[0][0].val : ''
          // color: this.getListData(item.formData, 'color')
        };
        return nItem;
      });
      if (list.length > 1) {
        list.unshift({
          columnName: '全部'
        });
      }
      this.columns = list;
      this.$nextTick(() => {
        this.swiperElNav = new Swiper(this.$refs.swiperNav, {
          navigation: {
            nextEl: ".btnRight",
            prevEl: ".btnLeft"
          },
          initialSlide: this.columnName ? this.columns.findIndex(item => {
            return this.columnName == item.columnName;
          }) : 0,
          direction: 'vertical',
          slidesPerView: 'auto',
          centeredSlides: true,
          touchMoveStopPropagation: true,
          runCallbacksOnInit: false,
          observer: true,
          //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true,
          loop: false
        });
      });
    },
    getListData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }).values[0];
      if (!target) return '';
      return type ? process.env.NODE_ENV == 'development' ? stageUrl + target.name : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '' : target.val;
    },
    getValInFormData(data, id, type, index) {
      index = index ? index : 0;
      if (!data[id] || !data[id].groupValues[index] || !data[id].groupValues[index].values || !data[id].groupValues[index].values[0] || !data[id].groupValues[index].values[0].length) {
        return '';
      }
      let target;
      if (type && type == 'img') {
        if (!data[id].groupValues[index].values[0][0]) return '';
        target = process.env.NODE_ENV == 'development' ? stageUrl + data[id].groupValues[index].values[0][0].name : data[id].groupValues[index].values[0][0].fileUrl;
        target = target && process.env.NODE_ENV != 'development' ? target.replace('http:', 'https:') : target;
      } else {
        target = type ? data[id].groupValues[index].values[0][0][type] : data[id].groupValues[index].values[0][0].val;
      }
      return target;
    },
    // 切换底部文物
    slideFun(e) {
      if (this.listPage < this.listTotal) {
        if ((this.swiperEl.realIndex + 1) % 10 == 0 || this.swiperEl.realIndex + 1 > 10 * (this.listPage - 1) || this.swiperEl.realIndex == this.list.length) {
          this.listPage++;
          this.getList();
        }
      }
    },
    clickDetail(index, m_index) {
      let target = this.list[index];
      let query = {
        fid: this.$route.query.fid,
        code: target.code
      };
      this.columnName ? query.columnName = this.columnName : '';
      this.pageType ? query.type = this.pageType : '';
      target.autoCode ? query.autoCode = target.autoCode : target.code == this.detailCode && m_index ? query.index = m_index : '';
      this.$router.replace({
        name: 'springwaterDetail',
        query
      });
      // `/springwaterDetail?fid=${}&code=${}${this.pageType ? `&type=${this.pageType}` : ''}${target.autoCode ? `&autoCode=${target.autoCode}` : `${target.code == this.detailCode ? `&index=${m_index || 0}` : ''}`}`)
    },
    // 获取底部文物信息列表
    getList(type) {
      let query = {
        deptId: this.$route.query.fid || '151066',
        formId: 113010,
        page: this.listPage,
        limit: 10,
        searchStr: ''
      };
      let a = {
        filters: [[{
          alias: "showType",
          compt: "checklist",
          express: "match",
          // id: 34,
          range: null,
          val: ['电脑端与移动端']
        }]],
        model: 0
      };
      if (this.columnName && this.columnName != '全部') {
        a.filters.push([{
          alias: this.$route.query.fid == 200375 ? "columns" : 'column',
          compt: "selectbox",
          express: "match",
          range: null,
          val: [this.columnName]
        }]);
      }
      this.listPage == 1 ? this.list = [] : '';
      query.searchStr = encodeURI(JSON.stringify(a));
      this.$api.singleadvanceSearch(query).then(res => {
        this.listTotal = res.totalPage;
        this.setListData(res.dataList, type);
      });
    },
    // 底部文物信息列表数据解析
    setListData(data, type) {
      let list = data.map((item, index) => {
        let n_code = this.getValInFormData(item.formIdValueData, 'autoId');
        let nItem = {
          columnName: this.$route.query.fid == 200375 ? this.getValInFormData(item.formIdValueData, 'columns') : this.getValInFormData(item.formIdValueData, 'column'),
          name: this.getValInFormData(item.formIdValueData, 'antiqueName'),
          img: this.getValInFormData(item.formIdValueData, 'thumbnail', 'img'),
          code: n_code,
          type: this.getValInFormData(item.formIdValueData, 'type'),
          index: index,
          m_index: 0,
          autoCode: this.getValInFormData(item.formIdValueData, 'autoCode')
        };
        return nItem;
      });
      // 手动塞重复数据的index
      list.map(item => {
        if (list.filter(l => {
          return l.code == item.code;
        }).length > 1) {
          let f_list = list.filter(l => {
            return l.code == item.code;
          });
          f_list.map((f, i) => {
            list[f.index].m_index = i;
          });
        }
      });
      if (this.$route.query.autoCode) {
        this.listPage > 1 ? list = list.filter(l => {
          return l.autoCode != this.$route.query.autoCode;
        }) : '';
      } else {
        this.listPage > 1 ? list = list.filter(l => {
          return !(l.code == this.detailCode && l.type == this.detail.type);
        }) : '';
      }
      this.list = this.list.concat(list);
      // console.log(list, 111)
      let that = this;
      if (this.listPage == 1) {
        this.$nextTick(() => {
          if (!this.$route.query.hideOthers) {
            this.swiperEl = new Swiper(this.$refs.swipercontainer, {
              navigation: {
                nextEl: ".btnTurnRight",
                prevEl: ".btnTurnLeft"
              },
              direction: 'horizontal',
              slidesPerView: 'auto',
              initialSlide: 0,
              centeredSlides: true,
              runCallbacksOnInit: false,
              touchMoveStopPropagation: true,
              slideToClickedSlide: true,
              observer: true,
              observeSlideChildren: true
            });
            let that = this;
            this.swiperEl.on('slideChangeTransitionEnd', function (e) {
              that.slideFun(e);
            });
          }
        });
        // 类型切换初始第一件文物
        if (type == 'changeColumn' && !this.detailCode) {
          if (!this.list.length) return;
          this.detailCode = this.list[0].code;
          this.showModels = [false, false, false];
          this.detail = this.list[0];
          console.log(this.detail, 'detail');
          this.showDetail = true;
          this.$nextTick(() => {
            this.$refs.lsDetail.slideFun();
          });
          return;
        }
        let m_index = this.$route.query.index || 0;
        this.activeIndex = this.list.findIndex(item => {
          return item.code == this.detailCode && (this.$route.query.autoCode ? this.$route.query.autoCode == item.autoCode : item.m_index == m_index);
        });
        this.$nextTick(() => {
          if (this.swiperEl) {
            this.swiperEl.slideTo(this.activeIndex);
          }
          this.showDetail = true;
        });
      }
    },
    _isMobile() {
      if (window.innerWidth == 1080) return true;
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    // 获取页面配置
    getConfig() {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid || '151066';
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        if (!data) {
          document.title = '文物综合展示系统';
          return this.getList();
        }
        this.config = {
          logo: this.getConfigInFormData(data.formData, 'logo', 'img'),
          title: this.getConfigInFormData(data.formData, 'title')
        };
        document.title = this.config.title || '文物综合展示系统';
        // 只有类型的时候默认显示第一个
        this.getList(this.$route.query.columnName ? 'changeColumn' : '');
        this.getColumn();
      });
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      if (!target) return '';
      target.file = process.env.NODE_ENV == 'development' ? `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}` : target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    }
  },
  created() {
    this.pageType = this.$route.query.type || '';
    if (this._isMobile()) {
      this.$cookie.set('_isMobile', true);
    } else {
      this.$cookie.delete('_isMobile');
    }
  },
  mounted() {
    this.detailCode = this.$route.query.code;
    // 带着类型参数
    if (this.$route.query.columnName) this.columnName = this.$route.query.columnName;
    this.getConfig();
  },
  computed: {
    isMobile() {
      return this.$cookie.get('_isMobile');
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.name == "springwaterDetail") {
        location.reload();
      }
    }

    // 'autoCloseNav' (val, oldVal) {
    //   if (val > 3) {
    //     this.showNavs = false
    //     clearInterval(timer)
    //   }
    // }
  }
};